import React, { createContext, useState, useContext } from 'react';

const CartContext = createContext();

export const products = [
  {
    id: 1,
    name: 'Nebula Strike Elite',
    price: 499,
    rating: 4.9,
    image: '/images/1.jpg',
    description: 'Opplev en episke sci-fi skytespill med banebrytende grafikk og dyp historie. Kjemper gjennom galaksen i dette actionfylte online mesterskapet.'
  },
  {
    id: 2,
    name: 'Cyber Quest Reborn',
    price: 599,
    rating: 4.8,
    image: '/images/2.jpg',
    description: 'Utforsk en futuristisk cyberby full av hemmeligheter og utfordringer. Dette rollespillet gir deg timevis med spennende oppdrag.'
  },
  {
    id: 3,
    name: 'Viking Battle Royale',
    price: 399,
    rating: 4.7,
    image: '/images/3.jpg',
    description: 'Kjemp som en viking i denne intense online overlevelsesspillet. Bygg, samarbeid og overvinn fiendene dine i episk skala.'
  },
  {
    id: 4,
    name: 'Mystic Realm Online',
    price: 699,
    rating: 4.9,
    image: '/images/4.jpg',
    description: 'Et fantastisk MMORPG hvor magi og myter møtes. Utforsk enorme verdener og skap legender i dette spennende eventyret.'
  },
  {
    id: 5,
    name: 'Quantum Racing Pro',
    price: 449,
    rating: 4.6,
    image: '/images/5.jpg',
    description: 'Kjør futuristiske racerbiler i lynende tempo. Quantum Racing Pro gir deg den ultimate raceropplevelsen med fantastiske effekter.'
  }
];

export function CartProvider({ children }) {
  const [cartItems, setCartItems] = useState([]);

  const addToCart = (product) => {
    setCartItems((prevItems) => {
      const existingItem = prevItems.find((item) => item.id === product.id);
      if (existingItem) {
        return prevItems.map((item) =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
      }
      return [...prevItems, { ...product, quantity: 1 }];
    });
  };

  const removeFromCart = (productId) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== productId));
  };

  const updateQuantity = (productId, newQuantity) => {
    if (newQuantity < 1) return;
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === productId
          ? { ...item, quantity: newQuantity }
          : item
      )
    );
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const getCartTotal = () => {
    return cartItems.reduce((total, item) => total + item.price * item.quantity, 0);
  };

  const getCartCount = () => {
    return cartItems.reduce((total, item) => total + item.quantity, 0);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        getCartTotal,
        getCartCount
      }}
    >
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart må brukes innenfor CartProvider');
  }
  return context;
}